import { render, staticRenderFns } from "./KioskForm.vue?vue&type=template&id=7fadde33&scoped=true"
import script from "./KioskForm.vue?vue&type=script&lang=js"
export * from "./KioskForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fadde33",
  null
  
)

export default component.exports